import { cn } from "@/lib/cn"

// Default cell type. Coerces non-string scalars to a string. Empty / null
// renders as an em-dash so empty cells don't collapse the row visually.
type Props = {
  value: string | number | boolean | null | undefined
  align?: "left" | "right" | "center"
  mono?: boolean
}

export function TextCell({ value, align = "left", mono = false }: Props) {
  const display =
    value === null || value === undefined || value === "" ? "—" : String(value)
  return (
    <span
      className={cn(
        "block min-w-0 truncate",
        align === "right" && "text-right",
        align === "center" && "text-center",
        mono && "font-mono text-[12px]",
        display === "—" && "text-app-subtle",
      )}
      title={display === "—" ? undefined : display}
    >
      {display}
    </span>
  )
}
